module.exports = __webpack_public_path__ + "img/icon-sofort.803cb092.svg";